window.WorkflowAutomationAPI = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);

    self.AUTOMATION_TYPES = {
        AUTOMATED_ONBOARDING: "AUTOMATED_ONBOARDING",
    }

    self.AUTOMATION_SUB_TYPES = {
        OFFER: "OFFER",
    }

    _protected.setApiUrl(publicConfiguration.getBaseAPI(['WorkflowAutomationManager']));

    self.getJobAutomationStatus = async (brandId, type, entityId) => {
        const url = `brands/${brandId}/settings/${type}/owner_entities/${entityId}/status`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    };

    self.enableAutomationForJob = async (brandId, type, entityId) => {
        const url = `brands/${brandId}/settings/${type}/owner_entities/${entityId}/enable`;
        const response = await _protected.request(url, 'POST');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    }

    self.disableAutomationForJob = async (brandId, type, entityId) => {
        const url = `brands/${brandId}/settings/${type}/owner_entities/${entityId}/disable`;
        const response = await _protected.request(url, 'POST');

        if (response?.status === 200) {
            return response;
        }

        throw response;
    }

    self.getEntityAutomation = async (brandId, type, entityId) => {
        const url = `brands/${brandId}/settings/${type}/entities/${entityId}/automations`;
        const response = await _protected.request(url, 'GET');

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    }

    self.getAutomationFields = async (brandId, type, positionCode) => {
        const url = `brands/${brandId}/settings/${type}/automation_fields`;
        const response = await _protected.request(url, 'GET', {position_code: positionCode});

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    }

    self.createEntityAutomation = async (brandId, type, entityId, payload) => {
        const url = `brands/${brandId}/settings/${type}/entities/${entityId}/automations`;
        const response = await _protected.request(url, 'POST', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    }

    self.updateEntityAutomation = async (brandId, type, entityId, automationId, payload) => {
        const url = `brands/${brandId}/settings/${type}/entities/${entityId}/automations/${automationId}`;
        const response = await _protected.request(url, 'PUT', payload);

        if (response?.status === 200 && response?.data?.data) {
            return response.data.data;
        }

        throw response;
    }
};